import { useQuery } from "@apollo/client";
import Loading from "./Loading";
import AlertDismissable from "./AlertDismissible";
import { ReactElement } from "react";

const Query = ({
  children,
  query,
  id,
  variables,
  dataOut,
  errorView,
  loadingLabel = "Loading",
  skip = false,
}: {
  children: any;
  query: any;
  id?: string;
  variables?: any;
  dataOut?: Function;
  errorView?: ReactElement;
  loadingLabel?: string;
  skip?: boolean;
}) => {
  const { data, loading, error } = useQuery(query, {
    skip,
    variables: { id: id, ...variables },
  });
  data && dataOut && dataOut(data);
  if (loading) return <Loading inline={true} label={loadingLabel} />;
  if (error)
    return (
      <>
      <AlertDismissable variant="warning">
        {error.graphQLErrors.map((e, i) => (
          <div key={`error-${i}`}>{e.message}</div>
        ))}
      </AlertDismissable>
      {errorView}
      </>
    );
  return data ? children({ data }) : null;
};

export default Query;
